import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';

import Store from 'store/store';
import 'store/bolt/footer';
import { accessNested, joinClasses } from 'utils/utils';
import Button from 'components/bolt/button/button';
import Close from 'components/bolt/icons/close';
import Socials from 'components/bolt/socials/socials';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {


	renderOpenFooter() {
		const {
			logos,
			links,
			copyright
		} = this.footerData;

		const footerBgStyling = accessNested(Store.get(), 'appData.styling.variables.footerBgColor', this.state.backgroundColor);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});


		const autoExpanding = this.state.autoExpanding;

		const footerStyle = {
			background: !this.pressKitFooter && footerBgStyling
		};
		
		const socials = this.props.store?.appData?.header?.powsterHeader?.follow;

		return (
			<div class={joinClasses(s.openWrapper, autoExpanding && s.autoExpanding)} style={footerStyle} role="contentinfo">
				<Button
					class={s.closeBtn}
					trigger={autoExpanding ? this.cancelAutoExpanding : this.toggleFooter}
					ariaLabel={accessibilityCopy.$COLLAPSE_FOOTER_ARIA}
				>
					<Close />
				</Button>
				<div class={joinClasses(s.studioDetails)}>
					{this.getLogos(logos)}
					{socials && (
						<Socials
							class={joinClasses(s.socials, this.state.open && s.open)}
							socials={socials}
							navOpen={this.state.open}
							key="socials"
						/>
					)}
					<div class={s.line} />
					<ul class={s.links}>
						{this.renderLinks(links, 'link')}
					</ul>
				</div>
				<ul class={joinClasses(s.copyright, this.fontStyles.footerCopyright)}>
					{this.renderLinks(copyright, 'copyright')}
				</ul>
			</div>
		);
	}
}